"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var FlowDownstreamFlowsFilteredByFlowOutputFieldQueryGql_1 = require("../../queries/FlowDownstreamFlowsFilteredByFlowOutputFieldQueryGql");
var FlowDownstreamFlowsQueryGql_1 = require("../../queries/FlowDownstreamFlowsQueryGql");
var PaginatedQueryWrapper_1 = require("../../wrappers/PaginatedQueryWrapper");
var FlowsDisplayGrid_1 = require("../sharedDisplayGrid/FlowsDisplayGrid");
function selectConnectionListResult(resultData) {
    var flow = resultData && resultData.flows && resultData.flows[0];
    return flow ? flow.downstreamFlowsConnection : null;
}
function selectConnectionListResultForFilteredQuery(resultData) {
    var flow = resultData && resultData.flows && resultData.flows[0];
    var flowOutputFields = flow && flow.outputFieldsConnection && flow.outputFieldsConnection.nodes;
    var field = flowOutputFields && flowOutputFields[0];
    return field ? field.downstreamFlowsConnection : null;
}
function FlowDownstreamFlowsQueryGrid(props) {
    var emptyGridMessage = Localize_1.Messages.EmptyDownstreamFlowsLineageGridMessage();
    var emptyFilteredGridMessage = Localize_1.Messages.EmptyDownstreamFilteredFlowsLineageGridMessage();
    return props.filteredFlowOutputFieldId ? (
    // Query with Selected Field as Filter
    React.createElement(PaginatedQueryWrapper_1.PaginatedQueryWrapper, { queryGql: FlowDownstreamFlowsFilteredByFlowOutputFieldQueryGql_1.FlowDownstreamFlowsFilteredByFlowOutputFieldQueryGql, partialQueryVariables: {
            flowVizportalUrlId: props.flowVizportalUrlId,
            selectedFlowOutputFieldId: props.filteredFlowOutputFieldId,
            orderBy: props.orderBy,
        }, selectConnectionListResult: selectConnectionListResultForFilteredQuery, mapResultNode: FlowsDisplayGrid_1.getRowDataForFlow }, function (_a) {
        var rowStore = _a.rowStore;
        return React.createElement(FlowsDisplayGrid_1.FlowsDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyFilteredGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder });
    })) : (
    // Query without Selection
    React.createElement(PaginatedQueryWrapper_1.PaginatedQueryWrapper, { queryGql: FlowDownstreamFlowsQueryGql_1.FlowDownstreamFlowsQueryGql, partialQueryVariables: {
            flowVizportalUrlId: props.flowVizportalUrlId,
            orderBy: props.orderBy,
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: FlowsDisplayGrid_1.getRowDataForFlow }, function (_a) {
        var rowStore = _a.rowStore;
        return React.createElement(FlowsDisplayGrid_1.FlowsDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder });
    }));
}
exports.FlowDownstreamFlowsQueryGrid = FlowDownstreamFlowsQueryGrid;
//# sourceMappingURL=FlowDownstreamFlowsQueryGrid.js.map